/**
 * Brand text.
 *
 * Static for now. Phase 11 replaces this with the company profile, which is when its
 * own exit criterion ("the logo appears on the login screen after saving") arrives
 * and a public branding endpoint has to exist to serve it.
 */
export const BRAND = {
  name: 'Flyst',
  tagline: 'Your gateway to global market',
} as const;
